import { c as _c } from "react/compiler-runtime";
import { type MediaOverlaySectionProps } from '@/app/lcv/components/sections/spartan/shared/media-overlay/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const MediaOverlaySection = t0 => {
  const $ = _c(16);
  const {
    aspectRatio,
    rounded: t1,
    className,
    style,
    media,
    contentClassName,
    contentStyle,
    testId: t2,
    children
  } = t0;
  const rounded = t1 === undefined ? true : t1;
  const testId = t2 === undefined ? "media-overlay-section" : t2;
  let t3;
  if ($[0] !== aspectRatio || $[1] !== className || $[2] !== rounded) {
    t3 = cn("relative w-full overflow-hidden", aspectRatio, {
      "isolate translate-z-0 rounded-lg": rounded
    }, className);
    $[0] = aspectRatio;
    $[1] = className;
    $[2] = rounded;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== testId) {
    t4 = createDataAttributes({
      test: testId
    });
    $[4] = testId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== contentClassName || $[8] !== contentStyle) {
    t5 = !!children && <div className={cn("absolute z-20", contentClassName)} style={contentStyle} {...createDataAttributes({
      test: "content"
    })}>{children}</div>;
    $[6] = children;
    $[7] = contentClassName;
    $[8] = contentStyle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== media || $[11] !== style || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t3} style={style} {...t4}>{media}{t5}</div>;
    $[10] = media;
    $[11] = style;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};